import { defineFeature } from '@/lib/platform/system';
import { scheduleDataMachine } from '@/features/schedule-data/state/schedule-data.machine';

export const features = [
  defineFeature({
    id: 'schedule-data',
    machine: scheduleDataMachine,
    emits: ['schedule-data.published'],
    handles: [],
    accepts: ['schedule-data.load-view', 'schedule-data.refresh', 'schedule-data.publish'],
  }),
] as const;
